module.exports = __webpack_public_path__ + "static/media/Barana-Costa-Rica.146b6193.jpg";